import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=b53c4a76&scoped=true&"
import script from "./BrandCard.vue?vue&type=script&lang=ts&"
export * from "./BrandCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandCard.vue?vue&type=style&index=0&id=b53c4a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53c4a76",
  null
  
)

export default component.exports